/**
 * Badges verdes de mensajes unread del portal: NUNCA mostrar con 0.
 * Normaliza strings/null/undefined/NaN a un entero >= 0.
 */
export function unreadMessageBadgeCount(value: unknown): number {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n) || n <= 0) {
    return 0;
  }
  return Math.floor(n);
}

export function shouldShowUnreadMessageBadge(value: unknown): boolean {
  return unreadMessageBadgeCount(value) > 0;
}

/** «Todos» dentro de un grupo (la etapa de inicio o la que se llama Todos): no lleva badge verde. */
export function isTodosVisibilityItem(item: { name?: string; defaultview?: boolean } | null | undefined): boolean {
  if (!item) {
    return false;
  }
  if (item.defaultview === true) {
    return true;
  }
  return String(item.name || '').trim().toLowerCase() === 'todos';
}
